import { render, staticRenderFns } from "./MultiHeaders.vue?vue&type=template&id=04348317&"
import script from "./MultiHeaders.vue?vue&type=script&lang=js&"
export * from "./MultiHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports